/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import * as api from '@codegrade/api';
import client from '@/client';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class NotificationSetting extends api.NotificationSettingOption {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    async updateValue(newValue, token = null) {
        await client.p.userSetting.patchNotificationSetting({
            token: token ?? undefined,
            requestBody: {
                reason: this.reason,
                value: newValue,
            },
        });
        this.value = newValue;
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class NotificationSettings {
    settings;
    possibleValues;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(settings, possibleValues) {
        this.settings = settings;
        this.possibleValues = possibleValues;
        Object.freeze(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static async loadFromServer(token = null) {
        const { body } = await client.p.userSetting.getAllNotificationSettings({
            token: token ?? undefined,
        });
        return new NotificationSettings(body.options.map(opt => new NotificationSetting(opt)), body.possibleValues);
    }
}
